import React from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import GeneralServices from '../../../app/service/generalServices'
import ConstantsUtil from '../../../context/constantsUtil'
import { Button } from 'primereact/button'
import EditProvisaoDialog from './editProvisaoDialog'
import ConfirmationDialog from '../../confirmationDialog'
import ProvisaoService from '../../../app/service/contasAPagar/provisaoService'
import * as popUp from '../../toastr'
import HandleErrorService from '../../../app/service/handleErrorService'
import TableFilters from '../../tableFilters'
import TooltipButton from '../../tooltipButton'
import CentralService from '../../../app/service/central/centralService'
import { classNames } from 'primereact/utils'
import DadosPagamentoSalvoParcelaProvisaoDialog from './dadosPagamentoSalvoParcelaProvisaoDialog'
import InformarDadosPagamentoDialog from './InformarDadosPagamentoDialog'
import { Dialog } from 'primereact/dialog'
import AuthService from '../../../app/service/authService'

class ProvisaoTable extends React.Component {

    constructor(){
        super();
        this.dt = React.createRef()
        this.tableFilters = new TableFilters();
        this.provisaoService = new ProvisaoService();
        this.generalServices = new GeneralServices();
        this.centralService = new CentralService();
    }

    state = {
        visibleConfirmDeleteDialog: false,
        fichaDeEstoqueToDelete: '',

        // valorTotal: null,
        filteredList: null,

        loading: false,

        displayEditDialog: false,
        idProvsisaoToEdit: '',
        empresaProvisaoToEdit: '',

        displayConfirmDeleteDialog: false,
        idProvisaoToDelete: '',
        empresaProvisaoToDelete: '',

        parcelasInformarPagamentoIdList: [],
        displayInformarPagamentoDialog: false,

        parcelaToViewDadosPagamento: {},
        displayDadosPagamentoDialog: false,

        displayConfirmDesfazerPagamentoDialog: '',
        parcelaProvisaoToDesfazerPagamento: '',

        displayConfirmDeleteRecorrenciaDialog: false,
        provisoesRecorrentesFuturas: [],
        confirmationDeleteRecorrenciaMessage: '',


    }


    doFilterTipoDePagamento = async (value) => {
        this.setState({selectedTipoDePagamento: value})
        this.dt.current.filter(value, ConstantsUtil.tipoDePagamentoNomeProperty, 'in');
    }

    isFiltroDataLancamento = () => {
        if(this.props.searchProvisaoResult){
            return this.props.searchProvisaoResult.filterTypeDate === ConstantsUtil.dataLancamentoValue
        }

        return true
    }

    getList(){
        if(!this.props.searchProvisaoResult){
            return []
        }

        if(this.isFiltroDataLancamento()){
            //Filtrado por data de lançamento
            return this.props.searchProvisaoResult.provisaoList
        }

        //Filtrado por data de pagamento
        return this.props.searchProvisaoResult.parcelaProvisaoList

    }

    // getValorColumnLabel = () => {
    //     if(this.isFiltroDataLancamento()){
    //         return "Valor da Provisão"
    //     }

    //     return "Valor da Parcela"

    // }

    getTableHeaders = () => {
        
        const filterTypeDate = this.props.searchProvisaoResult && this.props.searchProvisaoResult.filterTypeDate ?
            this.isFiltroDataLancamento() ? ConstantsUtil.dataLancamentoLabel : ConstantsUtil.dataPagamentoLabel
            : ''
            
        const filterTypeLabel = "Filtrado por: " + filterTypeDate

        const periodo = this.props.searchProvisaoResult && this.props.searchProvisaoResult.initialDate ? this.props.searchProvisaoResult.initialDate + " - " + this.props.searchProvisaoResult.finalDate : ""
        const periodoLabel = "Período: " + periodo

        return {filterTypeDate: filterTypeLabel, periodo: periodoLabel}
    }

    getIdProvisao = provisaoOuParcela => {
        let provisaoId;

        if(this.isFiltroDataLancamento()){
            //Filtrado por data de lançamento
            provisaoId = provisaoOuParcela.id
        }
        else{
            provisaoId = provisaoOuParcela.provisaoId
        }

        return provisaoId;

    }

    editProvisao = async provisaoOuParcela => {
        
        // console.log("editProvisao: ", provisaoOuParcela)

        await this.setState({idProvsisaoToEdit: this.getIdProvisao(provisaoOuParcela)})
        await this.setState({empresaProvisaoToEdit: provisaoOuParcela.empresa})
        this.setState({displayEditDialog: true})
        
    }

    getDataLabel = () => {
        return this.isFiltroDataLancamento() ? "Data de Lançamento" : "Data De Pagamento"
    }

    hideEditDialog = async () => {
        await this.setState({displayEditDialog: false})
        await  this.setState({idProvsisaoToEdit: ''})
        await  this.setState({empresaProvisaoToEdit: ''})
    }

    
    callDeleteProvisao = async (provisaoOuParcela) => {

        // console.log("callDeleteProvisao: ", provisaoOuParcela)
        await this.setState({idProvisaoToDelete: this.getIdProvisao(provisaoOuParcela)})
        await this.setState({empresaProvisaoToDelete: provisaoOuParcela.empresa})

        if(provisaoOuParcela.recorrencia){
            this.callDeleteProvisaoRecorrente(provisaoOuParcela)
        }
        else{
            this.setState({displayConfirmDeleteDialog: true})
        }

    }

    callDeleteProvisaoRecorrente = async (provisaoOuParcela) => {
        this.provisaoService.buscaProvisoesRecorrentesFuturas(this.getIdProvisao(provisaoOuParcela))
        .then(response => {
            // console.log("response: ", response.data)
            this.setState({
                provisoesRecorrentesFuturas: response.data.provisaoList,
                displayConfirmDeleteRecorrenciaDialog: true
            })
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
    }

    hideConfirmDeleteRecorrenciaDialog = () => {
        this.setState({
            provisoesRecorrentesFuturas: [],
            displayConfirmDeleteRecorrenciaDialog: false
        })
        this.hideConfirmDeleteDialog()
    }

    confirmDeleteProvisoesRecorrentes = () => {
        if(this.state.empresaProvisaoToDelete){
            popUp.infoPopUp("Funcionalidade não permitida em relatórios unificados.")
            return
        }

        AuthService.startBlockUi()
        this.provisaoService.deleteRecorrenciasByProvisaoBase(this.state.idProvisaoToDelete)
        .then(response => {
            popUp.successPopUp("Provisões recorrentes deletadas com sucesso!")
            this.hideConfirmDeleteRecorrenciaDialog()
            this.props.search(true)
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            AuthService.stopBlockUi()
        })
    }

    handleDeleteProvisaoById = () => {
        if(this.state.empresaProvisaoToDelete){
            return this.centralService.deleteProvisaoById(this.state.idProvisaoToDelete, this.state.empresaProvisaoToDelete.id)
        }
        else{
            return this.provisaoService.deleteById(this.state.idProvisaoToDelete)
        }
    }

    confirmDeleteProvisao = () => {

        this.setState({loading: true})

        AuthService.startBlockUi()
        this.handleDeleteProvisaoById()
        .then(response => {
            popUp.successPopUp("Provisão Deletada com Sucesso!")
            this.hideConfirmDeleteDialog()
            this.hideConfirmDeleteRecorrenciaDialog()   
            this.props.search(true)
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            this.setState({loading: false})
            AuthService.stopBlockUi()
        })

    }

    hideConfirmDeleteDialog = () => {
        this.setState({displayConfirmDeleteDialog: false})
        this.setState({idProvisaoToDelete: ''})
        this.setState({empresaProvisaoToDelete: ''})
    }

    getValorTotal = () => {

        try{
            let list;
            // console.log("this.state.filteredList: ", this.state.filteredList)
            // console.log("this.getList(): ", this.getList())
            if(this.state.filteredList){
                // console.log("entrou no filteredList")
                list = JSON.parse(JSON.stringify(this.state.filteredList))
            }
            else{
                list = JSON.parse(JSON.stringify(this.getList()))
            }
            // console.log("lista final: ", list)
            let result = GeneralServices.valueBodyTemplate(this.calculaValorTotal(list, false))
            // console.log("result: ", result)
            return result
        }
        catch(e) {
            console.log(e)
            return GeneralServices.valueBodyTemplate(0)
        }
    }

    calculaValorTotal = (currentTableList, isFilter) => {

        // console.log("calcualValorTotal: ", currentTableList)
        
        let valorTotal = 0
        currentTableList.forEach(item => {
            if(this.isFiltroDataLancamento()){
                valorTotal += item.valorTotal
            }
            else{
                valorTotal += item.valorFinalComAcrescimoDesconto
            }
        })
        // this.setState({valorTotal})

        if(this.props.calculaValorTotal){
            const filterTypeDate = this.props.searchProvisaoResult.filterTypeDate
            this.props.calculaValorTotal({
                filterTypeDate: filterTypeDate,
                provisaoList: filterTypeDate === ConstantsUtil.dataLancamentoValue ? currentTableList : [],
                parcelaProvisaoList: filterTypeDate === ConstantsUtil.dataPagamentoValue ? currentTableList : []
            })
        }

        if(isFilter){
            this.setState({filteredList: currentTableList})
        }
        // console.log("valor total: ", valorTotal)
        return valorTotal
    }

    search = (fromTable) => {
        this.props.search(fromTable)
        this.setState({loading: false})
    }

    getMappedItemToExport = (item) => {
        // console.log("getMappedItemToExport provisaoTable item: ", item)
        // console.log("getMappedItemToExport provisaoTable item prop: ", this.props.itemDre?.nome)
        let mappedItem = {
            [this.getDataLabel()]: item.data.replaceAll("-", "/"),
            ['Descrição']: item.historico,
            ['Valor']: this.isFiltroDataLancamento() ? item.valor : item.valorFinalComAcrescimoDesconto,
            ['Origem']: item.origem,
        }

        
        if(this.props.itemDre && this.props.grupoDre){
            Object.assign(mappedItem, {'Grupo Gerencial': GeneralServices.getNomeSemSimboloGrupoDre(this.props.grupoDre.titulo)})
            Object.assign(mappedItem, {'Conta Gerencial': this.props.itemDre.nome})
        }
        
        if(this.props.insideDre){
            Object.assign(mappedItem, {'Detalhamento': this.props.itemDre ? ConstantsUtil.getDetalhamentoOrigemLancamentoGrupoDeLancamento(this.props.itemDre.nome) : ''})
        }

        if(this.props.unificar){
            Object.assign(mappedItem, {'Empresa': item.empresa.nome})
        }

        return mappedItem

    }

    onFilterTable = (filteredList) => {
        this.setState({filteredList})
        this.calculaValorTotal(filteredList, true)
    }

    getListToExport = () => {

        let list = this.state.filteredList && this.state.filteredList.length > 0 ? this.state.filteredList : this.getList()

        let exportList = list.map(item => {
            return this.getMappedItemToExport(item)
        })

        exportList.push(
            {
                [this.getDataLabel()]: '',
                ['Descrição']: ConstantsUtil.totaisTableUpperCaseLabel,
                ['Valor']: this.getValorTotal()
            }            
        )
        
        return exportList
    }

    getFilenameToExport = () => {
        return `${this.isFiltroDataLancamento() ? 'Lançamentos_de_Provisão_de_Pagamento' : 'Pagamentos' }_de_${this.props.initialDate}_a_${this.props.finalDate}`
    }    

    exportXLSX = () => {
        // console.log("itemDre: ", this.props.itemDre)
        // console.log("grupoDre: ", this.props.grupoDre)
        let exportList = this.getListToExport()
        GeneralServices.exportExcel(exportList, "Vendas", this.getFilenameToExport())
    }

    exportPDF = () => {
        let columns = [
            {field:[this.getDataLabel()], header: this.getDataLabel()},
            {field:['Descrição'], header:"Descrição"},
            {field:['Valor'], header:"Valor"}
        ]

        if(this.props.unificar){
            columns.push({field:['Empresa'], header:"Empresa"})
        }

        let exportColumns = columns.map(col => ({ title: col.header, dataKey: col.field }))

        let exportList = this.getListToExport()
        GeneralServices.exportPdf(this.getFilenameToExport(), exportColumns, exportList)
    }

    renderStatus = (rowData, rowIndex) => {

        const classes = classNames({
            'superavitValue': rowData.status === ConstantsUtil.parcelaProvisaoPagaLabel,
            'deficitValue': rowData.status === ConstantsUtil.parcelaProvisaoAguardandoPagamentoLabel,
            'linkValue': rowData.status === ConstantsUtil.parcelaProvisaoPagaLabel
        });

        if(rowData.status === ConstantsUtil.parcelaProvisaoPagaLabel){
            return(
                <a 
                    className={classes}
                    onClick={() => this.viewDadosPagamento(rowData)}
                >
                    {GeneralServices.renderBodyColumnInOneLine(rowData.status, rowIndex)}
                </a>
            )
        }
        else{
            return(
                <div className={classes}>
                    {GeneralServices.renderBodyColumnInOneLine(rowData.status, rowIndex)}
                </div>
            )
        }
    }

    getTamanhoColunaAcoes = () => {
        if(this.isFiltroDataLancamento()){
            return "40px"
        }
        return "50px"
    }

    informarPagamento = (parcelaProvisao) => {
        this.setState({
            parcelasInformarPagamentoIdList: [parcelaProvisao.id],
            displayInformarPagamentoDialog: true
        })
    }

    onSaveInformarPagamento = () => {
        // this.hideInformarPagamentoDialog()
        this.search(true)
    }

    callDesfazerPagamento = (parcelaProvisao) => {
        this.setState({
            displayConfirmDesfazerPagamentoDialog: true,
            parcelaProvisaoToDesfazerPagamento: parcelaProvisao,
        })
    }

    desfazerPagamento = () => {
        this.setState({loading: true})
        this.hideConfirmDesfazerPagamentoDialog()
        this.provisaoService.desfazerPagamento(
            {
                idParcelaProvisaoList: [this.state.parcelaProvisaoToDesfazerPagamento.id]
            }
        )
        .then(response => {
            this.search(true)
        }).catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            this.setState({loading: false})
        })
        
    }

    hideInformarPagamentoDialog = () => {
        this.setState({
            parcelasInformarPagamentoIdList: [],
            displayInformarPagamentoDialog: false
        })
    }

    viewDadosPagamento = (parcelaProvisao) => {
        this.setState({
            parcelaToViewDadosPagamento: parcelaProvisao,
            displayDadosPagamentoDialog: true
        })
    }

    hideDadosPagamentoDialog = () => {
        this.setState({
            parcelaToViewDadosPagamento: {},
            displayDadosPagamentoDialog: false
        })
    }

    hideConfirmDesfazerPagamentoDialog = () => {
        this.setState({displayConfirmDesfazerPagamentoDialog: false})
        this.setState({parcelaProvisaoToDesfazerPagamento: ''})
    }

    reRenderEditDialog = async () => {
        // console.log("reRender provisaoTable")
        AuthService.startBlockUi()
        await this.setState({displayEditDialog: false})
        await this.generalServices.sleep(500)
        await this.setState({displayEditDialog: true})
        AuthService.stopBlockUi()
    }

    render(){

        const renderConfirmDeleteProvisaoDialog = () => {
            return(
                <ConfirmationDialog
                    visible={this.state.displayConfirmDeleteDialog}
                    header={"Deletar Lançamento de Provisão"}
                    confimationMessage={ "Deseja Confirmar?"}
                    confirm={this.confirmDeleteProvisao}
                    hide={this.hideConfirmDeleteDialog}
                />
            )
        }

        const confirmDeleteProvisaoRecorrenteFooter = () => {
            return (
                <>
                    <Button
                        label="Deletar apenas essa"
                        onClick={this.confirmDeleteProvisao}
                    />
                    <Button
                        label="Deletar todas"
                        className="right-button p-button-danger"
                        onClick={this.confirmDeleteProvisoesRecorrentes}
                    />
                </>
            )
        }

        const renderConfirmDeleteProvisaoRecorrenteDialog = () => {
            return(
                    <Dialog
                        visible={this.state.displayConfirmDeleteRecorrenciaDialog}
                        style={{ width: '40vw'}}
                        header="Deletar Provisão Recorrente"
                        modal
                        className="p-fluid"
                        footer={confirmDeleteProvisaoRecorrenteFooter}
                        onHide={this.hideConfirmDeleteRecorrenciaDialog}
                    >
                    <div className='col-md-12'>
                            Essa é uma provisão recorrente.
                            <br />
                            Deseja deletar apenas essa ou todas as demais?
                            <br />
                            As demais provisões dessa recorrência possuem as seguintes datas de pagamento:
                            <br />
                            {GeneralServices.getDatasPagamentosRecorrenciasFuturas(this.state.provisoesRecorrentesFuturas)}
                    </div>
                    </Dialog>
            )
        }

        const renderConfirmDesfazerPagamentoDialog = () => {
            return(
                <ConfirmationDialog
                    visible={this.state.displayConfirmDesfazerPagamentoDialog}
                    header={"Desfazer Pagamento"}
                    confimationMessage={ "Deseja Confirmar?"}
                    confirm={this.desfazerPagamento}
                    hide={this.hideConfirmDesfazerPagamentoDialog}
                />
            )
        }

        const renderValorProvisaoColumn = () => {
            if(this.isFiltroDataLancamento()){
                return(
                    <Column
                        header={"Valor da Provisão"}
                        field="valor" 
                        body = {rowData => GeneralServices.showFormattedIfNotNull(rowData.valor, true)}
                        sortable style ={ {width: '40px'} }
                        filter filterElement={valorProvisaoFilterElement}
                    />
                )
            }
        }

        const renderValorParcelaProvisaoColumn = () => {
            if(!this.isFiltroDataLancamento()){
                return(
                    <Column
                        header={"Valor da Parcela"}
                        field="valorFinalComAcrescimoDesconto" 
                        body = {rowData => GeneralServices.showFormattedIfNotNull(rowData.valorFinalComAcrescimoDesconto, true)}
                        sortable style ={ {width: '40px'} }
                        filter filterElement={valorParcelaProvisaoFilterElement}
                    />
                )
            }
        }

        const renderValorTotalProvisaoColumn = () => {
            if(!this.isFiltroDataLancamento()){
                return (
                    <Column
                        header="Valor Total da Provisão"
                        field="valorTotalProvisao" 
                        body = {rowData => GeneralServices.showFormattedIfNotNull(rowData.valorTotalProvisao, true)}
                        sortable style ={ {width: '40px'} }
                        filter filterElement={valorTotalProvisaoFilterElement}
                    />               
                )
            }
        }

        const renderStatusParcelaProvisaoColumn = () => {
            if(!this.isFiltroDataLancamento()){
                return (
                    <Column
                        header="Status"
                        field="status" 
                        // body = { (rowData, rowIndex) => GeneralServices.renderBodyColumnInOneLine(rowData.status, rowIndex)}
                        body = { (rowData, rowIndex) => this.renderStatus(rowData, rowIndex)}
                        sortable style ={ {width: '40px'} }
                        filter filterElement={statusFilterElement}
                    />
                )
            }
        }

        const renderEmpresaColumn = () => {
            if(
                // this.isFiltroDataLancamento() &&
                this.props.searchProvisaoResult
                && this.props.searchProvisaoResult.unificado
            )
            {
                return (
                    <Column
                        header="Empresa"
                        field="empresa.nome"
                        // body = {rowData => GeneralServices.showFormattedIfNotNull(rowData.valorTotalProvisao, true)}
                        sortable style ={ {width: '60px'} }
                        filter filterElement={empresaFilterElement}
                    />
                )
            }
        }

        const renderActionColumn = () => {
            if (this.props.onSelectProvisao) {
                return (
                    <Column
                        header=""
                        style={{ width: '80px' }}
                        body={rowData => (
                            <Button
                                label="Selecionar"
                                className="p-button-sm p-button-outlined"
                                onClick={() => this.props.onSelectProvisao(rowData)}
                            />
                        )}
                    />
                )
            }
            if(this.props.perfil && !this.props.perfil.isDiretor && !this.props.disabled){
                return (
                    <Column header="Ações" body={actionBody} style ={ {width: this.getTamanhoColunaAcoes()} }
                    />
                )
            }
        }

        const renderPagamentoButton = (parcelaProvisao) => {
            if(this.isFiltroDataLancamento()){
                return (<></>)
            }

            // if(parcelaProvisao.status === ConstantsUtil.parcelaProvisaoPagaLabel){
            //     return (
            //         <TooltipButton
            //             tooltip='Desfazer Pagamento'
            //             className={ "p-button-rounded p-button-danger p-mr-2 right-button" }
            //             icon="pi pi-undo"
            //             onClick={() => this.callDesfazerPagamento(parcelaProvisao)}
            //         />
            //     )
            // }

            // if(parcelaProvisao.status === ConstantsUtil.parcelaProvisaoAguardandoPagamentoLabel){
            //     return (
            //         <TooltipButton
            //             tooltip='Informar Pagamento'
            //             className={ "p-button-rounded p-button-success p-mr-2 right-button" }
            //             icon="pi pi-wallet"
            //             onClick={() => this.informarPagamento(parcelaProvisao)}
            //         />                    
            //     )
            // }

            return (<></>)

        }

        const actionBody = (provisaoOuParcela) => {
            return (
                <React.Fragment>
                    <TooltipButton
                        tooltip='Editar'
                        icon="pi pi-pencil"
                        onClick={() => this.editProvisao(provisaoOuParcela)}
                    />

                    {renderPagamentoButton(provisaoOuParcela)}

                    <TooltipButton
                        tooltip='Excluir'
                        className={ "p-button-rounded p-button-danger p-mr-2 right-button" }
                        icon="pi pi-times"
                        onClick={() => this.callDeleteProvisao(provisaoOuParcela)}
                    />

                </React.Fragment>
            );
        }

        const renderDadosPagamentoDialog = () => {
            return (
                <DadosPagamentoSalvoParcelaProvisaoDialog
                    visible={this.state.displayDadosPagamentoDialog}
                    hideDialog={this.hideDadosPagamentoDialog}
                    idParcelaToViewDadosPagamento={this.state.parcelaToViewDadosPagamento.id}
                />
            )
        }

        const renderInformarPagamentoDialog = () => {
            return (
                <InformarDadosPagamentoDialog
                    visible={this.state.displayInformarPagamentoDialog}
                    parcelasInformarPagamentoIdList={this.state.parcelasInformarPagamentoIdList}
                    hideDialog={this.hideInformarPagamentoDialog}
                    onSave={this.onSaveInformarPagamento}
                />
            )
        }

        //data Filter
        const dateFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedDate,
            this.getList(),
            "selectedDate",
            (name, value) => this.setState({[name]: value}),
            'data',
            '80px',
            "Selecione"
        )

        const dateVencimentoFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedDateVencimento,
            this.getList(),
            "selectedDateVencimento",
            (name, value) => this.setState({[name]: value}),
            'dataVencimento',
            '100%',
            "Selecione"
        )

        const dateLancamentoProvisaoParcelaFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedDataLancamentoProvisaoParcela,
            this.getList(),
            "selectedDataLancamentoProvisaoParcela",
            (name, value) => this.setState({[name]: value}),
            'dataLancamentoProvisao',
            '100%',
            "Selecione"
        )

        const dateCompetenciaProvisaoParcelaFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedDataCompetenciaProvisaoParcela,
            this.getList(),
            "selectedDataCompetenciaProvisaoParcela",
            (name, value) => this.setState({[name]: value}),
            'dataCompetenciaProvisao',
            '100%',
            "Selecione"
        )

        //valorProvisao Filter
        const valorProvisaoFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedValorProvisao,
            this.getList(),
            "selectedValorProvisao",
            (name, value) => this.setState({[name]: value}),
            'valor',
            '100%',
            "Selecione"
        )

        const valorParcelaProvisaoFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedValorProvisao,
            this.getList(),
            "selectedValorProvisao",
            (name, value) => this.setState({[name]: value}),
            'valorFinalComAcrescimoDesconto',
            '100%',
            "Selecione"
        )

        //valor Total Provisao Filter (Apresentado apenas quando o filtro for Data de Lançamento)
        const valorTotalProvisaoFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedValorTotalProvisao,
            this.getList(),
            "selectedValorTotalProvisao",
            (name, value) => this.setState({[name]: value}),
            'valorTotalProvisao',
            '80px',
            "Selecione"
        )

        //empresa Provisao Filter (Apresentado apenas quando o filtro for Data de Lançamento)
        const empresaFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedEmpresaProvisao,
            this.getList(),
            "selectedEmpresaProvisao",
            (name, value) => this.setState({[name]: value}),
            'empresa.nome',
            '100%',
            "Selecione"
        )


        //Fornecedor Filter
        const nomeFornecedorFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedNomeFornecedor,
            this.getList(),
            "selectedNomeFornecedor",
            (name, value) => this.setState({[name]: value}),
            'nomeFornecedor',
            '100px',
            "Selecione"
        )

        //Tipo de Pagamento Filter
        const tipoDePagamentoFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedTipoDePagamento,
            this.getList(),
            "selectedTipoDePagamento",
            (name, value) => this.setState({[name]: value}),
            ConstantsUtil.tipoDePagamentoNomeProperty,
            '100px',
            "Selecione"
        )

        //Grupo de Pagamento Filter
        const grupoDePagamentoFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedGrupoDePagamento,
            this.getList(),
            "selectedGrupoDePagamento",
            (name, value) => this.setState({[name]: value}),
            'grupoDePagamento.nome',
            '100%',
            "Selecione"
        )

        //N° Doc Filter
        const numeroDocumentoFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedNumeroDocumento,
            this.getList(),
            "selectedNumeroDocumento",
            (name, value) => this.setState({[name]: value}),
            'numeroDocumento',
            '80px',
            "Selecione"
        )

        //Origem Filter
        const origemFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedOrigens,
            this.getList(),
            "selectedOrigens",
            (name, value) => this.setState({[name]: value}),
            'origem',
            '100%',
            "Selecione"
        )

        //Histórico Filter
        const historicoFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedHistorico,
            this.getList(),
            "selectedHistorico",
            (name, value) => this.setState({[name]: value}),
            'historico',
            '120px',
            "Selecione"
        )

        const recorrenciaFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedRecorrencia,
            this.getList(),
            "selectedRecorrencia",
            (name, value) => this.setState({[name]: value}),
            'recorrenciaString',
            '100%',
            "Selecione"
        )

        const statusFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedStatus,
            this.getList(),
            "selectedStatus",
            (name, value) => this.setState({[name]: value}),
            'status',
            '100%',
            "Selecione"
        )

        const renderBotaoExportarExcel = () => {
            return (
                <Button
                    label="Exportar"
                    icon="pi pi-file-excel"
                    className="p-button-success small-font small-button"
                    onClick={this.exportXLSX}
                    tooltip={ConstantsUtil.exportXlsxLabel}
                    tooltipOptions={{position: 'top'}}
                />
            )
        }

        const renderBotaoExportarPDF = () => {
            return (
                <Button
                    label="Exportar"
                    icon="pi pi-file-pdf"
                    className="p-button-danger small-font small-button"
                    onClick={this.exportPDF}
                    style={{marginLeft: '10px'}}
                    tooltip={ConstantsUtil.exportPdfLabel}
                    tooltipOptions={{position: 'top'}}
                />
            )
        }

        const renderInfoValorTotal = () => {
            return (
                <>
                    <Button
                        label={ (this.isFiltroDataLancamento() ? 'Valor Total' : 'Valor Total das Parcelas') + ": " + this.getValorTotal()}
                        className="p-button-success"
                    />                
                </>
            )
        }

        const renderNormalHeader = () => {
            return (
                <div className = "card-header">
                <div className='col-md-12'>
                    <div className='row'>
                        <div className='col-md-4'>
                            {renderBotaoExportarExcel()}
                            {renderBotaoExportarPDF()}
                        </div>
                        <div className='col-md-4'>
                        </div>
                        <div className='col-md-4 d-flex justify-content-end'>
                            {renderInfoValorTotal()}
                        </div>
                    </div>
                    
                </div>
                </div>                
            )
        }

        const renderHeaderWhenInsideDialog = () => {
            return (
                <div className = "card-header">
                <div className='col-md-12'>
                    <div className='row'>
                        <div className='col-md-2'>
                            {renderBotaoExportarExcel()}
                        </div>
                        <div className='col-md-2'>
                            {renderBotaoExportarPDF()}
                        </div>
                        <div className='col-md-4'>
                        </div>
                        <div className='col-md-4 d-flex justify-content-end'>
                            {renderInfoValorTotal()}
                        </div>
                    </div>
                    
                </div>
                </div>                
            )
        }

        const renderHeader = () => {
            if (this.props.onSelectProvisao) {
                return null
            }
            if(this.props.insideDialog){
                return renderHeaderWhenInsideDialog()
            }
            else{
                return renderNormalHeader()
            }
        }

        const renderColunasDatasEspecificasParcelas = () => {
            if(!this.isFiltroDataLancamento()){
                /*
                Ou seja, está filtrado por Data de Pagamento ou Data de Vencimento (parcela).
                */
                return(
                    [
                        <Column
                            header={ConstantsUtil.dataLancamentoLabel}
                            field="dataLancamentoProvisao"
                            sortable style ={ {width: '45px'} }
                            filter filterElement={dateLancamentoProvisaoParcelaFilterElement}
                        />,
                        <Column
                            header={ConstantsUtil.dataCompetenciaLabel}
                            field="dataCompetenciaProvisao"
                            sortable style ={ {width: '45px'} }
                            filter filterElement={dateCompetenciaProvisaoParcelaFilterElement}
                        />,
                        <Column
                            header={ConstantsUtil.dataVencimentoLabel}
                            field="dataVencimento"
                            sortable style ={ {width: '45px'} }
                            filter filterElement={dateVencimentoFilterElement}
                        />
                    ]
                )
            }
        }

        if(this.props.isExportacaoAutomatica){
            return (
                <></>
            )
        }

        return (
            <>
            
                {renderHeader()}

                <DataTable
                    ref={this.dt}
                    value={this.getList()}
                    className="p-datatable-sm small-font"
                    rowHover
                    showGridlines
                    scrollable
                    scrollHeight="500px"
                    // onValueChange={filteredList => this.calculaValorTotal(filteredList, true)}
                    onValueChange={this.onFilterTable}
                    emptyMessage={ConstantsUtil.nenhumLancamentoEncontradoMessage}
                    loading={this.props.loading || this.state.loading}
                    dataKey="id"
                    paginator rows={ConstantsUtil.initialTableQuantityOption}
                    paginatorTemplate={GeneralServices.tablePaginatorTemplate(ConstantsUtil.initialTableQuantityOption, this.getList().length)}
                    currentPageReportTemplate="Mostrando de {first} ao {last} de {totalRecords} lançamentos"
                >

                {renderColunasDatasEspecificasParcelas()}

                <Column
                    header={this.getDataLabel()}
                    field="data"
                    // body={rowData => rowData.dataString}
                    sortable style ={ {width: '45px'} }
                    filter filterElement={dateFilterElement}
                />

                {/* <Column
                    header={this.getValorColumnLabel()}
                    field="valor" 
                    // body = {rowData => renderViewLancamentosLink(rowData, rowData.entrada, false, rowData.tipo !== ConstantsUtil.saldoLabel, ConstantsUtil.entradaLabel)}
                    body = {rowData => GeneralServices.showFormattedIfNotNull(this.isFiltroDataLancamento() ? rowData.valor : rowData.valorFinalComAcrescimoDesconto, true)}
                    sortable style ={ {width: '40px'} }
                    filter filterElement={ this.isFiltroDataLancamento() ? valorProvisaoFilterElement : valorParcelaProvisaoFilterElement}
                /> */}

                {renderValorProvisaoColumn()}

                {renderValorParcelaProvisaoColumn()}

                {renderValorTotalProvisaoColumn()}

                <Column
                    header="Fornecedor"
                    field='nomeFornecedor'
                    body = { (rowData, rowIndex) => GeneralServices.renderBodyColumnInOneLine(rowData.nomeFornecedor, rowIndex)}
                    sortable style ={ {width: '50px'} }
                    filter filterElement={nomeFornecedorFilterElement}
                />

                <Column
                    header="Tipo de Pagamento"
                    field={ConstantsUtil.tipoDePagamentoNomeProperty}
                    body = { (rowData, rowIndex) => GeneralServices.renderBodyColumnInOneLine(rowData.tipoDePagamento.nome, rowIndex)}
                    sortable style ={ {width: '70px'} }
                    filter filterElement={tipoDePagamentoFilterElement}
                />

                {/* <Column
                    header="Grupo de Pagamento"
                    field='tipoDePagamento.grupoDePagamento.nome'
                    body = { (rowData, rowIndex) => GeneralServices.renderBodyColumnInOneLine(rowData.tipoDePagamento.grupoDePagamento.nome, rowIndex)}
                    sortable style ={ {width: '70px'} }
                    filter filterElement={grupoDePagamentoFilterElement}
                /> */}

                <Column
                    header="Grupo de Pagamento"
                    field='grupoDePagamento.nome'
                    body = { (rowData, rowIndex) => {
                        // if(!rowData.grupoDePagamento){
                        //     console.log("rowData sem GP")
                        //     console.log(rowData)
                        //     return ''

                        // }
                        return GeneralServices.renderBodyColumnInOneLine(rowData.grupoDePagamento?.nome, rowIndex)
                    }}
                    sortable style ={ {width: '70px'} }
                    filter filterElement={grupoDePagamentoFilterElement}
                />


                <Column
                    header="N° Documento"
                    field="numeroDocumento"
                    // body = {rowData => renderViewLancamentosLink(rowData, rowData.saldo, true, rowData.tipo === ConstantsUtil.saldoLabel, ConstantsUtil.saldoLabel)}
                    body = { (rowData, rowIndex) => GeneralServices.renderBodyColumnInOneLine(rowData.numeroDocumento, rowIndex)}
                    sortable style ={ {width: '50px'} }
                    filter filterElement={numeroDocumentoFilterElement}
                />

                <Column
                    header="Origem da Provisão"
                    field='origem'
                    body = { (rowData, rowIndex) => GeneralServices.renderBodyColumnInOneLine(rowData.origem, rowIndex)}
                    sortable style ={ {width: '60px'} }
                    filter filterElement={origemFilterElement}
                />

                <Column
                    header="Histórico"
                    field="historico"
                    body = { (rowData, rowIndex) => GeneralServices.renderBodyColumnInOneLine(rowData.historico, rowIndex)}
                    sortable style ={ {width: '60px'} }
                    filter filterElement={historicoFilterElement}
                />

                <Column
                    header="Recorrência / Estimativa"
                    field="recorrenciaString"
                    sortable style ={ {width: '40px'} }
                    body={rowData => GeneralServices.renderStyledColorTableColumn(rowData.recorrenciaString , rowData.recorrencia)}
                    filter filterElement={recorrenciaFilterElement}
                />

                {renderStatusParcelaProvisaoColumn()}
                
                {renderActionColumn()}

                {renderEmpresaColumn()}                

            </DataTable>

            <EditProvisaoDialog
                visible={this.state.displayEditDialog}
                provisaoId={this.state.idProvsisaoToEdit}
                empresa={this.state.empresaProvisaoToEdit}
                // search={this.props.search}
                search={this.search}
                startLoadingTable={() => this.setState({loading: true})}
                finishLoadingTable={() => this.setState({loading: false})}
                hideDialog={this.hideEditDialog}
                reRender={this.reRenderEditDialog}
                insideDre={this.props.insideDre}
                unificar={this.props.unificar}                
            />

            {renderConfirmDeleteProvisaoDialog()}

            {renderConfirmDeleteProvisaoRecorrenteDialog()}

            {renderConfirmDesfazerPagamentoDialog()}

            {renderInformarPagamentoDialog()}

            {renderDadosPagamentoDialog()}

        </>
        )
    }

}


export default ProvisaoTable